import { Variants } from 'framer-motion'

export const LOGO_VARIANTS: Variants = {
  initial: {
    opacity: 0,
    translateY: 150,
  },
  enter: {
    opacity: 1,
    translateY: 0,
    transition: {
      type: 'spring',
      stiffness: 80,
      delay: 0.5,
    },
  },
  exit: {
    opacity: 0,
    translateY: -150,
    transition: {
      type: 'spring',
      duration: 0.8,
      delay: 0.5,
    },
  },
}

export const LAYERS_VARIANTS: Variants = {
  initial: {
    opacity: 0,
  },
  enter: {
    opacity: 1,
    transition: {
      delayChildren: 1,
      staggerChildren: 0.2,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      staggerChildren: 0.1,
      staggerDirection: -1,
      when: 'afterChildren',
    },
  },
}

export const ITEM_VARIANTS: Variants = {
  initial: {},
  enter: {},
  exit: {},
}

export const ITEM_LAYER_VARIANTS: Variants = {
  initial: {
    opacity: 0,
    scale: 0.6,
    rotate: -80,
  },
  enter: {
    opacity: 1,
    scale: 1,
    rotate: 0,
    transition: {
      type: 'spring',
      duration: 0.8,
    },
  },
  exit: {
    scale: 0,
    opacity: 0.6,
    rotate: -80,
    transition: {
      type: 'spring',
      duration: 1,
    },
  },
}
